import { toTons } from "./utils";

export type ConverterFn = (v: number, u?: string | null) => number;

export enum ConverterName {
  noneConverter = "noneConverter",
  durationConverter = "durationConverter",
  weightConverter = "weightConverter",
  percentageConverter = "percentageConverter"
}

export const converters: Record<ConverterName, ConverterFn> = {
  noneConverter: (value: number): number => value,
  durationConverter: (value: number, unit?: string | null):  number => {
    switch (unit) {
      case "h":
        return value / 3600;
      case "min":
        return value / 60;
      default:
        return value;
    }
  },
  weightConverter: (value: number, unit?: string | null): number => {
    switch (unit) {
      case "US ton":
        return toTons(value);
      case "Ton":
        return toTons(value, false);
      default:
        return value;
    }
  },
  percentageConverter: (value: number): number => value * 100
};


